<template>
    <div class="autocomplete">
        {{ $t('Test') }}
        {{ $t('Test2') }}
        <AutocompleteForm
            :autocompleteUrl="autocompleteUrl"
            :placeholder="input.placeholder"
            v-model="keyword"
            @searched="setMatches"
        />
        <AutocompleteResults
            v-if="isOpen"
            :isOpen="visibleForm"
            :matches="matches"
            :keyword="keyword"
            :totals="totals"
        />
    </div>
</template>

<script>
export default {
    components: {
        AutocompleteForm: () => import('./Form'),
        AutocompleteResults: () => import('./Results'),
    },
    props: {
        data: {
            type: Object,
            required: false,
            default: function() {
                return {
                    remote: false,
                    url: '/',
                    matches: [],
                };
            },
        },
        input: {
            type: Object,
            required: false,
            default: function() {
                return {
                    limit: 3,
                    placeholder: 'Search',
                };
            },
        },
        models: {
            type: Array,
            required: false,
            default: function() {
                return [];
            },
        },
        autocompleteUrl: {
            type: String,
            default: '/search/autocomplete',
        },
        responseDataType: {
            type: String,
            default: 'jquery',
        },
    },
    data() {
        return {
            isOpen: false,
            keyword: '',
            matches: {
                count: 0,
                items: {},
            },
            totals: {},
            activeTabIndex: 0,
            categoryId: null,
        };
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    destroyed() {
        document.destroyed('click', this.handleClickOutside);
    },
    methods: {
        setMatches(keyword, matches) {
            this.keyword = keyword;

            let totals = matches.filter(item => item.type == 'totals');

            this.totals = totals ? totals[0] : {};

            matches = matches.filter(item => {
                return (
                    item.type != 'heading' &&
                    item.type != 'noresults' &&
                    item.type != 'totals' &&
                    item.type != 'all'
                );
            });

            this.matches.count = matches.length;
            this.matches.items = {};

            matches.forEach(match => {
                if (this.matches.items[match.table_name] === undefined) {
                    this.matches.items[match.table_name] = [];
                }

                this.matches.items[match.table_name].push(match);
            });

            this.showMatches();

            return true;
        },
        showMatches() {
            this.isOpen = true;
            this.selectedIndex = 0;

            this.$el.dispatchEvent(new CustomEvent('autocompleteShow'));

            if (typeof window.rEvent.dispatch === 'function') {
                window.rEvent.dispatch('Autocomplete.show');
            }
        },
        isActiveTab(item) {
            return item == this.activeTab;
        },
        showTab(item) {
            this.activeTabIndex = this.navItems.indexOf(item);
        },
        handleClickOutside($event) {
            if (!this.$el.contains($event.target) && this.isOpen) {
                this.isOpen = false;
                this.selectedIndex = -1;

                this.$el.dispatchEvent(new CustomEvent('autocompleteHide'));

                if (typeof window.rEvent.dispatch === 'function') {
                    window.rEvent.dispatch('Autocomplete.hide');
                }
            }
        },
    },
    computed: {
        hasMatches: function() {
            return this.matches.count > 0;
        },
        showNav: function() {
            return this.hasMatches && this.navItems.length > 1;
        },
        navItems: function() {
            return Object.keys(this.matches.items);
        },
        activeTab: function() {
            var activeTabIndex =
                typeof this.navItems[this.activeTabIndex] !== 'undefined'
                    ? this.activeTabIndex
                    : 0;

            return this.navItems.length > 0
                ? this.navItems[activeTabIndex]
                : null;
        },
    },
};
</script>

<i18n>
{
  "en": {
  },
  "sk": {
    "Test": "jadro i18n",
    "Test2": "ooooo"
  }
}
</i18n>
